import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useStore } from "../lib/store";

const NAV = [
  { id: "inicio", label: "Inicio" },
  { id: "sobre-nosotros", label: "Sobre Nosotros" },
  { id: "servicios", label: "Servicios" },
  { id: "promociones", label: "Promociones" },
  { id: "galeria", label: "Galería" },
  { id: "testimonios", label: "Testimonios" },
  { id: "contacto", label: "Contacto" },
];

export const Header = () => {
  const { business } = useStore();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md shadow-[0_1px_20px_rgba(0,0,0,0.06)]"
          : "bg-white/70 backdrop-blur-md border-b border-white/40"
      }`}
    >
      <div className="container-aura flex items-center justify-between h-20">
        <button
          onClick={() => go("inicio")}
          data-testid="header-logo"
          className="flex items-center gap-3 group"
        >
          <div className="w-10 h-10 rounded-full flex items-center justify-center bg-ink transition-all">
            <span className="font-serif text-lg text-gold">A</span>
          </div>
          <div className="text-left leading-tight">
            <div className="font-serif text-xl tracking-tight text-ink">AURA</div>
            <div className="text-[10px] tracking-luxe uppercase text-ink-soft">Estética & Spa</div>
          </div>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => go(n.id)}
              className="text-sm font-medium text-ink hover:text-gold transition-colors duration-300 relative group"
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-gold transition-all duration-300 group-hover:w-full"></span>
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button onClick={() => go("reservas")} className="btn-gold" data-testid="header-cta-reserve">
            Reservar
          </button>
        </div>

        <button
          className="lg:hidden p-2 text-ink hover:text-gold transition-colors"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white/95 backdrop-blur-md border-t border-beige-200" data-testid="mobile-menu">
          <div className="container-aura py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => go(n.id)}
                className="text-left text-base text-ink hover:text-gold transition-colors py-2"
              >
                {n.label}
              </button>
            ))}
            <button onClick={() => go("reservas")} className="btn-gold mt-2" data-testid="mobile-cta-reserve">
              Reservar Cita
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
